import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './TimerPage.css';

const TimerPage: React.FC = () => {
    const location = useLocation();
    const { state } = location;
    const initialTime = state?.duration || 120; // Duration in seconds
    const [timeLeft, setTimeLeft] = useState<number>(initialTime);
    const navigate = useNavigate();
    
    // Store the start time when component mounts
    const [startTime] = useState(() => Date.now());

    useEffect(() => {
        // Update timer every second
        const interval = setInterval(() => {
            const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
            const remaining = Math.max(0, initialTime - elapsedSeconds);
            setTimeLeft(remaining);

            if (remaining <= 0) {
                console.log('Timer ended. Fetch result or notify user.');
                navigate('/result-page');
            }
        }, 1000);

        // Cleanup interval on unmount
        return () => clearInterval(interval);
    }, [startTime, initialTime, navigate]);

    const timePercentage = (timeLeft / initialTime) * 100;

    const getStrokeColor = () => {
        if (timePercentage > 50) return '#4caf50';
        if (timePercentage > 20) return '#ffeb3b';
        return '#f44336';
    };

    const handleContinue = () => navigate('/result-page');
    const handleClose = () => navigate(-1);

    return (
        <div className="timer-modal">
            <div className="timer-content">
                <div className="timer-header">
                    <h2>XAU/USD</h2>
                    <button className="close-btn" onClick={handleClose}>×</button>
                </div>
                <div className="timer-circle-container">
                    <svg className="timer-svg" viewBox="0 0 36 36">
                        <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                        <path
                            className="circle"
                            strokeDasharray={`${timePercentage}, 100`}
                            stroke={getStrokeColor()}
                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <text x="18" y="20.35" className="timer-text">
                            {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}
                        </text>
                    </svg>
                </div>
                <div className="timer-footer">
                    <button className="btn-close" onClick={handleClose}>Close</button>
                    <button className="btn-continue" onClick={handleContinue}>Continue</button>
                </div>
            </div>
        </div>
    );
};

export default TimerPage;